import React from 'react';
import styled from 'styled-components';
import { getPopUpAction } from "../../modules/cs/customserviceModule";
import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import style from '../../../node_modules/dom-helpers/cjs/css';
import {isMobileOnly} from 'react-device-detect';
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";

const HpPopUpMobileContainerBlock = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    padding-bottom: 0;
    overflow: visible;
    width: 100%;
    z-index: 10;
`;

const HpPopUpMobileContainer2Block = styled.div`
    position: fixed;
    bottom: 40px;
    left: 0;
    height : 20px;
    padding-bottom: 0;
    overflow: visible;
    width: 100%;
    //z-index: 1;
    background-color: #ffffff;
`;

const HpPopUpMobileBlock = styled.div`

  position:relative;
  display: block;
  height: ${isMobileOnly?'60vw':'650px'};  
  //margin-left: 4vw;
  //margin-top: ${isMobileOnly?'60px':'80px'};
  width: 100%;
  text-align: center;

  .main-slide-inner {
    ${!isMobileOnly&&`width:1176px; margin:0 auto`};
    }
  
  .slick-slider {
      opacity: 0;
      visibility: hidden;
      //animation: fadeOut ease-out 1s;
      //-webkit-transition: opacity 5s ease-in;
      &.slick-initialized {
      //animation: fadeIn ease-in 1s;
      visibility: visible;
      opacity: 1;    
      }
      z-index:1;  
  }
  
 
  //.slick-slider .slick-list { border-bottom-left-radius: 40px;}
  .link {display:unset !important  } // to avoid gap between image and wrapper div  
  .slide-img {
    display: block;
    vertical-align: middle;
    cursor: pointer;
    background-color: #ffc742;
    ${isMobileOnly?`
        object-fit:cover;
        width:100%;
        //height:96vw;    
        // border-bottom-left-radius:40px;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        height: 60vw;
    `:`
        margin:0 auto; 
        object-fit:cover;
        width:1176px;
        height:650px;
        // border-bottom-left-radius:40px;    
    `};
    //animation: fadeIn ease-in-out 0.5s;
    
  }
`;

const HpPopUpMobileBottomBlock = styled.div`
    width: 100%;
    height: 50px;
    background-color: #ffffff;
    z-index: 10;
`;

const HpPopupMobileSpanBlock = styled.span`
    display: inline-block;
    line-height: 50px;
    color: #666;
    font-size: 14px;
    float: left;
    //margin-left: 30px; 
    width: 125px;
    text-align: center;
`;

const HpPopupMobileButtonContainerBlock = styled.p`
    display: inline-block;
    line-height: 50px;
    color: #111;
    font-size: 14px;
    float: right;
    //margin-right: 30px; 
    font-weight: 500;
    width: 58px;
    text-align: center;
`;

const HpPopupMobileNumBlock = styled.div`
    position: absolute;
    top: 20px;
    right: 30px;
    letter-spacing: 3px;
    bottom: auto;
    left: auto;
    width: 43px;
    height: 20px;
    z-index: 10;
    opacity: 0.6;
    border-radius: 10px;
    background-color: #111111;
    padding: 0 10px 0 10px;
`;
const HpPopupMobileNumSpanBlock = styled.span`
    //display: inline-block;
    //position: relative;
    line-height: 20px;
    
    font-size: 12px;
    width : 10px;
    height : 20px;
    font-weight: 400;
    color : #ffffff;
    margin: auto;
    float: left;
`;

const MOBILE_POPUP = "MOBILE_POPUP"

const HpPopUpMobileContainer = () => {
    const [display, setDisplay] = useState(false);
    const dispatch = useDispatch();
    const [close, setClose] = useState(true);
    const [updatePopUp, setUpdatePopUp] = useState([]);
    const slider = useRef();
    const [curSlider, setCurSlider] = useState(1);

    const { popUpData } = useSelector(
        ({ customserviceReducer }) => ({
            popUpData: customserviceReducer.popUpData
        })
    );
    const popUps = [];

    const IMG = (item1)=>{
        let item = item1?item1.item:null;
        // return(isMobileOnly?<img className="slide-img" alt={item.bnnr_title} src={item.bnnr_img_mo_url} style={{objectFit:"cover", width:"100vw", height:"300px"}}/>:
        //   <img alt={item.bnnr_title} src={item.bnnr_img_url} style={{margin:"0 auto", objectFit:"cover",width:"1176px",height:"650px",borderBottomLeftRadius:"40px"}} />);
        // return(item?<img className="slide-img" alt={item.bnnr_title} src={isMobileOnly?item.bnnr_img_mo_url:item.bnnr_img_url}/>:
        //     <img className="slide-img dummy" alt="이미지 로딩중..."
        //          src={isMobileOnly?"https://via.placeholder.com/500x300.png?text=https://www.odgagu.co.kr":
        //       "https://via.placeholder.com/1176x650.png?text=https://www.odgagu.co.kr"}/>
        //       )
    
        return(item&&<img className="slide-img" alt={item.title} src={isMobileOnly?item.img_url:item.img_url}/>
        )
      }
      const settings = {
        arrows: false,
        lazyLoad:false,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        className: 'main-slide-inner',
        adaptiveHeight: true,
        
        afterChange: (current) => setSlideNumber(current)
      };

    useEffect(() => {
        if(popUpData === null){
            let param = '?isMobile=1&limit=3'
            dispatch(getPopUpAction(param));
        }

        if(popUpData != null && popUpData.length > 0){
            console.log("popUpData = " + JSON.stringify(popUpData))
            var todayDate = new Date();
            var updateData = [];

            for(var  i = 0; i < popUpData.length && i < 3; i++){

                //var name = popUpData[i].landing_url + todayDate.getDate();
                var name = MOBILE_POPUP + todayDate.getDate();
                var cookie = getCookie(name);

                if(cookie === "1"){

                }
                else {
                    updateData.push(popUpData[i]);
                }
            }

            if(updateData && updateData.length > 0){
                setClose(false);
                setDisplay(true);
            }

            setUpdatePopUp(updateData);
        }

    }, [popUpData]);

    const setSlideNumber = (current) => {
        console.log("current = " + current)
        setCurSlider(current + 1);
    }

    const setCookie = (name, value, expiredays) => {
        var todayDate = new Date();
        let valueSave = name+todayDate.getDate();
        todayDate.setDate(todayDate.getDate() + expiredays);
        //console.log("valueSave = "+ valueSave)
        document.cookie = valueSave + '=' + escape(value) + '; path=/; expires=' + todayDate.toGMTString() + ';';
    }

    const getCookie = (name) => {
        var cookiedata = document.cookie;
        var obj = name + "=";

        var x = 0;

        while ( x <= document.cookie.length )
        {
            var y = (x+obj.length);
            var endOfCookie;
            if ( document.cookie.substring( x, y ) == obj )
            {
                if ((endOfCookie=document.cookie.indexOf( ";", y )) == -1 )
                    endOfCookie = document.cookie.length;

                return unescape( document.cookie.substring( y, endOfCookie ) );
            }

            x = document.cookie.indexOf( " ", x ) + 1;

            if ( x == 0 )
                break;

        }

        return "";
    }

    const handlePopupTodayClose = () => {

        setCookie(MOBILE_POPUP, "1", 1);
        setClose(true)
        //console.log("index = " + index + "isDayNoShow = " + isDayNoShow)
        /* if(index === 0){
            if(isDayNoShow){
                //setCookie(FIRST_POPUP, updatePopUp[0].landing_url, 1);
                setCookie(updatePopUp[0].landing_url, "1", 1);
            }

            setClose1(true);
        }
        else {
            if(isDayNoShow){
                //setCookie(SECOND_POPUP, updatePopUp[1].landing_url, 1)
                setCookie(updatePopUp[1].landing_url, "1", 1)
            }
            setClose2(true);

        } */
    }

    const handlePopupClose = () => {
        setClose(true);
    }

    if(display === false || close === true){
        return <div/>;
    }

    const getSlideCount = () => {
        if(updatePopUp === null || updatePopUp === undefined || updatePopUp.length < 1 || curSlider === null){
            return;
        }
        let count = curSlider + "/" + updatePopUp.length;
        return count;
    }

    return (
        <HpPopUpMobileContainerBlock>
            <HpPopUpMobileContainer2Block/>
            <HpPopUpMobileBlock>
                <Slider ref={s=>slider.current = s} {...settings} >
                    {console.log("updatePopUp = " + JSON.stringify(updatePopUp))}
                    {updatePopUp&&updatePopUp.length&&updatePopUp.map((item,key) => {
                    return(
                        <a className="link" key={key} href={item.landing_url} style={{verticalAlign:"middle", display:"block"}}>
                        <IMG key={item.id} item={item}/>
                        </a>
                    )
                    })}
                </Slider>
            </HpPopUpMobileBlock>
            <HpPopUpMobileBottomBlock>
                <HpPopupMobileSpanBlock onClick={handlePopupTodayClose}>오늘은 그만 보기</HpPopupMobileSpanBlock>
                <HpPopupMobileButtonContainerBlock onClick={handlePopupClose}>닫기</HpPopupMobileButtonContainerBlock>
            </HpPopUpMobileBottomBlock>
            {updatePopUp&&updatePopUp.length < 2 ? "" :
            <HpPopupMobileNumBlock>
            <HpPopupMobileNumSpanBlock>{updatePopUp&&updatePopUp.length&&curSlider}</HpPopupMobileNumSpanBlock>
            <HpPopupMobileNumSpanBlock style={{width:"7px"}}>/</HpPopupMobileNumSpanBlock>
            <HpPopupMobileNumSpanBlock style={{width:"6px"}}>{updatePopUp&&updatePopUp.length}</HpPopupMobileNumSpanBlock>
             
        </HpPopupMobileNumBlock>
            }
            
        </HpPopUpMobileContainerBlock>
    );
};

export default HpPopUpMobileContainer;
